import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-556c96ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "legend"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical-line" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-circle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "active-legend-circle" }),
  /*#__PURE__*/_createElementVNode("span", { class: "active-legend-line" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-circle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "active-legend-circle" }),
  /*#__PURE__*/_createElementVNode("span", { class: "active-legend-line" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-circle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "active-legend-circle" }),
  /*#__PURE__*/_createElementVNode("span", { class: "active-legend-line" })
], -1))
const _hoisted_6 = {
  key: 1,
  class: "swipe-up-action flash"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Swipe Down "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" To Go Back")
], -1))

import { ref, computed } from 'vue'
import useStore from '../store/useStore'
import InfoButtonSVG from './svgs/InfoButtonSVG.vue';
import SwipeArrowUpSVG from './svgs/SwipeArrowUpSVG.vue';
import InfoModal from '../components/InfoModal.vue'
import { data } from "@/data/dataHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'LegendBar',
  setup(__props) {

const store = useStore()
const languageUtilities = computed(() => {
  return data.translationsByLanguage(store.language);
})

const showInfoModal = ref(false)
const closeInfoModal = () => {
  showInfoModal.value = false
}

const openInfoModal = () => {
  showInfoModal.value = true

}

if (store.isElectron) {
  store.legendTimeout = setInterval(() => {
    if (store.legendState !== 0) store.showLegend = !store.showLegend
  }, 7000)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "legend-wrapper",
    style: _normalizeStyle({ 'margin-top': `-${_unref(store).scrollTop}px` })
  }, [
    _createVNode(_Transition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(store).showLegend)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("ul", null, [
                _createElementVNode("li", {
                  class: _normalizeClass([_unref(store).legendState === 0 && 'activeState']),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(store).goToIntro && _unref(store).goToIntro(...args)))
                }, [
                  _createElementVNode("p", null, _toDisplayString(_unref(languageUtilities).introductionText), 1),
                  _hoisted_3
                ], 2),
                _createElementVNode("li", {
                  class: _normalizeClass([_unref(store).legendState === 1 && 'activeState']),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(store).goToMenu && _unref(store).goToMenu(...args)))
                }, [
                  _createElementVNode("p", null, _toDisplayString(_unref(languageUtilities).exploreText), 1),
                  _hoisted_4
                ], 2),
                _createElementVNode("li", {
                  class: _normalizeClass([_unref(store).legendState === 2 && 'activeState']),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(store).goToTimeline && _unref(store).goToTimeline(...args)))
                }, [
                  _createElementVNode("p", null, _toDisplayString(_unref(languageUtilities).timelineText), 1),
                  _hoisted_5
                ], 2)
              ])
            ]))
          : (!_unref(store).showLegend && _unref(store).isElectron)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(SwipeArrowUpSVG, { class: "animate-pulse-down" })
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(store).isElectron)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "info-button",
          onClick: openInfoModal
        }, [
          _createVNode(InfoButtonSVG)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      appear: "",
      name: "fade-short",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (showInfoModal.value)
          ? (_openBlock(), _createBlock(InfoModal, {
              key: 0,
              onClose: closeInfoModal
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 4))
}
}

})